import React from 'react';
import ViewLeavesPage from './ViewLeavesPage';
import { LEAVE_HISTORY_HEADER } from './ViewAttendeesPageHelper';
import { LEAVE_PAGE_TYPE } from '../../utils/Constant';

const LeaveHistory: React.FunctionComponent = () => {
  return (
    <ViewLeavesPage
      type={LEAVE_PAGE_TYPE.LEAVE_HISTORY}
      columnsHeder={LEAVE_HISTORY_HEADER}
      title="Leave History"
    />
  );
};
export default LeaveHistory;
